import React from 'react';
import { Link } from 'react-router-dom';

import ProductImage from './ProductImage';
import styles from './ProductCard.module.css';

const ProductCard = ({
  legacyPostId,
  productName,
  brandName,
  sku,
  imageUrl,
  isPublic,
}) => (
  <li className={styles.container}>
    <Link
      to={`/admin/product-catalog/edit/${legacyPostId}`}
      className={styles.link}
    >
      {!isPublic && <span className={styles.private}>PRIVATE</span>}
      <div className={styles.imageContainer}>
        <ProductImage src={imageUrl} alt={productName} />
      </div>
      <div className={styles.product}>
        <div className={styles.nameContainer}>
          <p className={styles.brand}>{brandName}</p>
          <p className={styles.name}>{productName}</p>
        </div>
        <p className={styles.sku}>{sku}</p>
      </div>
    </Link>
  </li>
);

export default ProductCard;
